import React, { useState, useEffect } from "react";
import AddNewTeamStyles from "./AddNewTeam.styles";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import { Box, Grid, Step, StepLabel, Stepper, Typography } from "@mui/material";
import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as CloseIcom } from "../../../../assets/icons/close.svg";
import PersonalDetails from "../stepper/Personal Details/PersonalDetails";
import OfficialInformation from "../stepper/OfficialInformation/OfficialInformation";
import EmployeeDocuments from "../stepper/EmployeeDocuments/EmployeeDocuments";
import LeaveDetails from "../stepper/LeaveDetails/LeaveDetails";
import SalaryInformation from "../stepper/SalaryInformation/SalaryInformation";
import { isTruthy, openErrorNotification } from "../../../../helpers/methods";
import notifiers from "../../../../global/constants/NotificationConstants";
const stepData = ["Lead Details", "Additional Information"];

interface CustomProps {
  isDialogOpen: boolean;
  handleCloseAddTeam: Function;
  userId: string;
  setUserId: Function;
  fromSettingOrLogout?: string;
  addNewTeamDialog: any;
  eventForEdit: any;
}

const AddNewTeam = (props: CustomProps) => {
  const classes = AddNewTeamStyles;
  const [activeStep, setActiveStep] = useState<number>(0);
  const [completed, setCompleted] = useState<{
    [k: number]: boolean;
  }>({});

  // useEffect(() => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: 'smooth',
  //   });
  // }, [activeStep]);
  console.log(props, "responseforadd");
  const totalSteps = () => {
    return stepData.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  // step 1 form validation method
  const handleStepOneValidation = () => {
    return true;
  };

  // go to next page method
  const nextStep = (next = activeStep) => {
    if (handleStepOneValidation()) {
      const newActiveStep =
        isLastStep() && !allStepsCompleted()
          ? stepData.findIndex((step, i) => !(i in completed))
          : next + 1;
      setActiveStep(newActiveStep);
    } else if (next >= 1) {
      setActiveStep(next + 1);
    }
  };

  const backStep = () => {
    setActiveStep(activeStep - 1);
  };

  // const handleNextValidation = (index: number) => {
  //   try {
  //     if (!props.userId.length) {
  //       throw 'Please Register  user';
  //     }
  //     setActiveStep(index);
  //     nextStep(index - 1);
  //   } catch (error: any) {
  //     openErrorNotification(' Please Register  user');
  //   }
  // };

  const getAllContent = (activeStep: number) => {
    switch (activeStep) {
      case 0:
        return (
          <PersonalDetails
            userId={props.userId}
            handleCloseAddTeam={props.handleCloseAddTeam}
            nextStep={nextStep}
            setUserId={props.setUserId}
            addNewTeamDialog={props.addNewTeamDialog}
            fromSettingOrLogout={props.fromSettingOrLogout}
            eventForEdit={props.eventForEdit}
          />
        );

        break;
    }
  };

  const dialogTitleContent = () => {
    return (
      <>
        <Box sx={classes.profileWrapper}>
          <Grid container>
            <Grid item xs={0}>
              {/* {stepperMethod()} */}
            </Grid>
            <Grid item xs={10} mx={"auto"}>
              {getAllContent(activeStep)}
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };

  const dialogHeaderContent = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
        <CloseIcom onClick={() => props.handleCloseAddTeam()} />
      </Box>
    );
  };

  return (
    <>
      <CustomDialog
        fullScreen={true}
        isDialogOpen={props.isDialogOpen}
        dialogHeaderContent={dialogHeaderContent()}
        dialogTitleContent={dialogTitleContent()}
        handleDialogClose={props.handleCloseAddTeam}
      />
    </>
  );
};

export default AddNewTeam;
